import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=6b45e716&scoped=true&lang=pug&"
import script from "./PlanForm.vue?vue&type=script&lang=js&"
export * from "./PlanForm.vue?vue&type=script&lang=js&"
import style0 from "./PlanForm.vue?vue&type=style&index=0&id=6b45e716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b45e716",
  null
  
)

export default component.exports